export default class ShopClick {
  constructor(itemPayload) {
    const { customMarketID, size } = itemPayload;
    const [removeSizeID] = customMarketID.split('SZ');

    this.removeSizeID = removeSizeID;
    this.size = size || '';
  }

  /**
   * Retrieves the item categories and generates a list name based on the available categories.
   *
   * @return {string} The generated list name.
   */
  static getItemCategory() {
    const itemCategories = window.ItemCategories || [];
    const category = {
      itemCategory: itemCategories[0] || '',
      itemCategory2: itemCategories[1] || '',
      itemCategory3: itemCategories[2] || '',
      itemCategory4: itemCategories[3] || '',
      itemCategory5: itemCategories[4] || '',
    };
    const listName = Object.values(category).reduce((acc, val) => {
      if (val) {
        return acc ? `${acc}--${val}` : val;
      }
      return acc;
    }, '');

    return listName;
  }

  /**
   * Retrieves information about the GA item.
   *
   * @return {Object} An object containing the item list name and an array of GA4 items.
   */
  getGAItemInfo() {
    const itemCategories = window.ItemCategories || [];
    const itemList = window.dataLayer.find((ele) => ele.ecommerce && ele.ecommerce.impressions);
    const listName = ShopClick.getItemCategory();
    let item = {};

    if (itemList) {
      item =
        itemList.ecommerce.impressions.find((obj) => {
          return obj.id === this.removeSizeID;
        }) || {};
    }

    const { id, name, price } = item;

    const ga4Item = {
      index: 0,
      item_id: id || '',
      item_name: name || '',
      item_list_name: listName,
      item_brand: this.size,
      itemCategory: itemCategories[0] || '',
      itemCategory2: itemCategories[1] || '',
      itemCategory3: itemCategories[2] || '',
      itemCategory4: itemCategories[3] || '',
      itemCategory5: itemCategories[4] || '',
      price: price ? parseInt(price) : '',
      quantity: 1,
    };

    return {
      itemListName: listName,
      items: [ga4Item],
    };
  }
}
